//import { JSONGeometricShape } from "../../../Palettes/Headerbar/toolbarButtonOpen";
import { registerRendererGroup, ShapeFunctions } from "../../util/shapeCategorySingleton";
import { circleSnapPointCalculator, circleSplitByLine, createCircle, globalCircle, transformCircleToInternalShape } from "./Circle";
import { createCircleBase } from "./CircleBase";
import { createDefaultPropertyPalette } from "./CircleDefaultPropertyPalette";
import { createPropertyPalette } from "./CirclePropertyPalette";
import { createCircleRubber } from "../../tools/CircleRubber";

const circleFunctions: ShapeFunctions = {
    shapeRendererGroup: {
        shapeRender: createCircle,
        rubberlineRender: createCircleRubber,
        baseShapeRenderer: createCircleBase,
    },
    shapeTransformerGroup: {
        snapPointCalculator: circleSnapPointCalculator,
        rectangleIntersectCheck: (s: GeometricShape, r: RectSel) => { return false; },

        globalShapeTransformer: globalCircle,
        transformToInternalShape: transformCircleToInternalShape,
        calculateWidthHeight: (s: GeometricShape) => { return { width: 0, height: 0 } },
        shapeSplit: circleSplitByLine,
    },
    UIElementRender: {
        propertyPaletteRenderer: createPropertyPalette,
        defaultPropertyPaletteRenderer: createDefaultPropertyPalette,
    }
}

registerRendererGroup(
    "circle",
    circleFunctions,
);

